




































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import EventBus from "@/utils/eventBus";
import * as types from "@/store/constants/types";
import { isIos } from "@/utils/lodash";
import NumUtils from "@/utils/numUtils";
import { sendEvent } from "@/utils/analytics";
import {updateEventObj} from "@/utils/sendEventUtil"
import BakcPress, { RECOMMEND_OFFER } from "@/utils/backPress";
import {updateProcessState} from '@/utils/initialProcessState'
import deepClone from "@/utils/deepCloneUtil";
import * as AppLifeCycle from "@/utils/appLifeCycle";
import GeneralUtilsHelper from "@/utils/generalUtils";
import {transformResult} from '@/utils/localizedUtil'

@Component({
  components: {

  }
})
export default class FreeFollowersDialog extends Vue {
  @Action(types.PAY_BY_ANY)
  private payByAny: any;
  @Getter(types.GETTER_LOCALIZE_PRICE)
  private localizePrice: any;
  @Getter(types.GETTER_INFO_BY_OFFER_DATA)
  private getterInfoByOffer: any;
  @Action(types.SHAKE_PLAY)
  private shakePlay: any;

  private showDialog: boolean = false;
  // private shake: any;
  private shakeDelay: any;
  private hasShake: boolean = false;

  private followList: any = [{
    header_uri: require("@/assets/icons-file/recommendOffer/pic_start_supersale1@2x.png"),
    content_uri: require("@/assets/icons-file/recommendOffer/pic_start_supersale2@2x.png"),
    class: 'super_sale',
    icon: require('@/assets/icons-file/sku/icon_followers.png')
  }, {
    header_uri: require("@/assets/icons-file/recommendOffer/pic_follow_bigsale1@2x.png"),
    content_uri: require("@/assets/icons-file/recommendOffer/pic_follow_bigsale2@2x.png"),
    class: 'big_sale_follow',
    icon: require('@/assets/icons-file/sku/icon_followers.png')
  }];

  private coinList: any = [{
    header_uri: require("@/assets/icons-file/recommendOffer/pic_start_coinsale1@2x.png"),
    content_uri: require("@/assets/icons-file/recommendOffer/pic_start_coinsale2@2x.png"),
    class: 'special_offer',
    icon: require('@/assets/icons-file/coins/coins_3.png')
  }, {
    header_uri: require("@/assets/icons-file/recommendOffer/pic_coin_bigsale1@2x.png"),
    content_uri: require("@/assets/icons-file/recommendOffer/pic_coin_bigsale2@2x.png"),
    class: 'big_sale_coin',
    icon: require('@/assets/icons-file/coins/coins_2.png')
  }];

  private showUiItem: any = {};
  private showItem: any = {};
  private header_uri_loading: boolean = false;
  private content_uri_loading: boolean = false;

  private animate_class: any = false;
  private listenKeyStr: string = "recommendOffer";

  get localizePriceText() {
    return GeneralUtilsHelper.localizePriceText;
  }

  get format() {
    return NumUtils.format;
  }

  private localizePriceOriginalText(item: any) {
    if (isIos()) {
      let price: any;
      let result: any;
      if (this.localizePrice(item.iap.product_id)) {
        price = NumUtils.toDecimal2(
                Math.floor(
                        (this.localizePrice(item.iap.product_id).price /
                                (1 - item.discount / 100)) *
                        100
                ) / 100
        );
        result = `${
                this.localizePrice(item.iap.product_id).localSymbol
                } ${transformResult(price)}`
      } else {
        price = this.getterInfoByOffer(item).original_price;
        result = `$ ${transformResult(price)}`
      }
      return result;
    } else {
      return `$ ${this.getterInfoByOffer(item).original_price}`;
    }
  }

  private closeDialog() {
    this.clearState();
    this.showDialog = false;
    this.content_uri_loading = false;
    this.header_uri_loading = false;
    BakcPress.destroy(RECOMMEND_OFFER);
    AppLifeCycle.removeListener(this.listenKeyStr);
    AppLifeCycle.removeGoBackListener(this.listenKeyStr);
  }

  private closeContinue() {
    this.closeDialog();
    updateProcessState({key: 'recommendOffer', offer: null});
  }

  // 预加载图片
  private loadImage(url: any, callback: any) {
    const img: any = new Image(); // 创建image对象，实现预加载
    img.onload = () => {
      img.onload = null;
      callback(img);
    };
    img.src = url;
  }

  private buyNow() {
    this.payByAny({
      offer: this.showItem
    }).catch((err: any) => {});;
    this.closeDialog();
    sendEvent('uia_start_recommend_click', this.showItem.kind === 'follow' ? 'crazy_followers' : 'feed_coins');
    updateEventObj({ key: "uia_start_recommend_buy", value: this.showItem.kind === 'follow' ? 'crazy_followers' : 'feed_coins' })
  }

  // 图片加载好之后更新状态
  private imgPreloadSuccess(name: string) {
    name === "content_uri_loading" ? this.content_uri_loading = true : this.header_uri_loading = true
  }

  // 定义计算属性
  get preloadProcess() {
    const {content_uri_loading, header_uri_loading} = this;
    return {content_uri_loading, header_uri_loading}
  }
  // 监听预加载状态的计算属性
  @Watch("preloadProcess", { immediate: true })
  private changeState(val: any) {
    if (val.content_uri_loading && val.header_uri_loading) {
      this.showDialog = true;
      AppLifeCycle.addGoBackListener({
        key: this.listenKeyStr,
        fn: async () => {
          this.clearState()
        }
      });

      AppLifeCycle.addListener({
        key: this.listenKeyStr,
        fn: async () => {
          this.clearState();
          this.initShakeState()
        }
      });
      this.initShakeState();
      if (GeneralUtilsHelper.isEmptyAccount()) {
        updateProcessState({key: 'recommendOffer', offer: this.showItem});
      }
    }
  }

  private mounted() {
    EventBus.$on("recommend-offer-show", (obj: any) => {
      updateProcessState({key: 'recommendOffer', offer: null});
      this.showItem = deepClone(obj);

      let num: number;
      if (this.showItem.randomNum) {
        num = this.showItem.randomNum;
      } else {
        num = Math.round(Math.random());
        this.showItem.randomNum = num;
      }
      // 获取随机数，再四舍五入
      const list = obj.kind === 'follow' ? this.followList : this.coinList;
      this.showUiItem = list[num];

      this.loadImage(this.showUiItem.content_uri, () => this.imgPreloadSuccess("content_uri_loading"));
      this.loadImage(this.showUiItem.header_uri, () => this.imgPreloadSuccess("header_uri_loading"));

      sendEvent('uia_start_recommend_show', obj.kind === 'follow' ? 'crazy_followers' : 'feed_coins');
      BakcPress.listen({
        key: RECOMMEND_OFFER,
        fn: () => {
          this.closeContinue();
        }
      });
    });
  }

  private initShakeState() {
    this.$nextTick(() => {
      this.shakeDelay = setTimeout(() => {
        this.animate_class = true;
        if (this.hasShake) {
          return;
        }
        this.shakePlay({android: 200, ios: 1});
        this.hasShake = true;
        // this.shake = setInterval(() => this.shakePlay({android: 200, ios: 1, name: 'recommendOffer'}), 4000)
      }, 1200);
    })
  }

  private clearState() {
    this.animate_class = false;
    // clearInterval(this.shake);
    clearTimeout(this.shakeDelay);
  }
}
